import { useTranslation } from "react-i18next";

import { Button, Divider, Stack } from "@mzc-pdc/ui";
import LanguageMenu from "@features/language-menu/language-menu";
import useLanguageMenu from "@hooks/useLanguageMenu";
import useTermsLinks from "@hooks/useTermsLinks";
import { FooterWrapper } from "./styled";

const WelcomeFooter = () => {
    const { t } = useTranslation();
    const languageMenu = useLanguageMenu();
    const { openTermsPrivacy, openTermsService } = useTermsLinks(languageMenu.locale);

    return (
        <FooterWrapper>
            <Stack direction={"row"} alignItems={"center"}>
                <Button size={"small"} variant={"text"} color={"secondary"} onClick={openTermsService}>
                    {t(`common::label::Terms & Conditions`)}
                </Button>
                <Divider orientation={"vertical"} flexItem />
                <Button
                    size={"small"}
                    variant={"text"}
                    color={"greySecondary"}
                    onClick={openTermsPrivacy}
                    sx={{ fontWeight: 500 }}
                >
                    {t(`common::label::Privacy policy`)}
                </Button>
            </Stack>
            <LanguageMenu
                locales={languageMenu.locales}
                locale={languageMenu.locale}
                label={languageMenu.label}
                onClick={languageMenu.onChange}
            />
        </FooterWrapper>
    );
};

export default WelcomeFooter;
